import { format } from 'date-fns'

import { CalendarSource } from '../../../constants/calendar'
import { CalendarGridMode } from '../../../constants/calendarGrid'
import { DATE_API_DATA_FORMAT_SHORT } from '../../../constants/date'

import { CALENDAR_VIEW_NO_TASK_TYPES_COUNT } from './CalendarView.constants'

function getIsCalendarViewTaskTypesEmpty(calendar) {
  return calendar.meta.taskTypesEnabled === CALENDAR_VIEW_NO_TASK_TYPES_COUNT
}

function getIsCalendarViewNoTaskTypes({ calendar, filters }) {
  const hasTaskDeadlines = filters.sources.includes(CalendarSource.taskDeadline)

  return hasTaskDeadlines && getIsCalendarViewTaskTypesEmpty(calendar)
}

function getIsCalendarViewEmpty(calendar) {
  return (
    !calendar.isLoading && !calendar.isRefetching && calendar.items.length === 0
  )
}

function getCalendarViewEmptyRangeText({ calendar, t }) {
  switch (calendar.mode) {
    case CalendarGridMode.agenda:
      return t('Calendar.EmptyAgendaKey')
    case CalendarGridMode.day:
      return t('Calendar.EmptyDayKey')
    default:
      return t('Calendar.EmptyRangeKey')
  }
}

function getCalendarViewEmptyText({ calendar, filters, t }) {
  if (filters.sources.length === 0) {
    return t('Calendar.EmptyNoSourceKey')
  }

  return getIsCalendarViewNoTaskTypes({ calendar, filters })
    ? t('Calendar.EmptyNoTaskTypesKey')
    : getCalendarViewEmptyRangeText({ calendar, t })
}

export function getHasCalendarViewNoTaskTypesNotice({ calendar, filters }) {
  return (
    calendar.items.length > 0 &&
    getIsCalendarViewNoTaskTypes({ calendar, filters })
  )
}

export function getCalendarViewBodyMessage({ calendar, filters, t }) {
  if (calendar.serverError) {
    return {
      action: { callback: calendar.handleReload, text: t('Calendar.RetryKey') },
      text: t('Calendar.ErrorLoadKey'),
    }
  }

  if (!getIsCalendarViewEmpty(calendar)) {
    return null
  }

  return { text: getCalendarViewEmptyText({ calendar, filters, t }) }
}

export function getCalendarViewRequestKey({ filters, today }) {
  return JSON.stringify({
    filters,
    today: format(today, DATE_API_DATA_FORMAT_SHORT),
  })
}
